import { mockedSortFields, CLEARANCE_STATUS_BY_CODE } from './constants';
import { getTemplateName } from './utils';

const { locale } = window.inlineGlobalConfig;
const { categoryId } = window.inlinePlp || {};

export const mapAdvancedCommerceResponse = fullApiResponse => {
  const template = getTemplateName(categoryId);
  const results = fullApiResponse?.elements?.[template]?.products?.results;
  const meta = fullApiResponse?.elements?.[template]?.products?.meta;
  const header = fullApiResponse?.header;

  if (!Array.isArray(results) || !header || !meta) {
    return { products: [], searchMetadata: { facets: [], totalItems: 0 } };
  }

  const formatPrice = value => {
    if (typeof value !== 'number') return null;
    return new Intl.NumberFormat(header.language_culture, {
      style: 'currency',
      currency: header.currency,
    }).format(value);
  };

  const getFeatureValue = feature => {
    if (!feature || !feature.options) return null;
    const firstOptionKey = Object.keys(feature.options)[0];
    return firstOptionKey ? feature.options[firstOptionKey]?.definition?.titles?.default : null;
  };

  const mappedProducts = [];

  results.forEach((product, index) => {
    const { item } = product;

    if (item?.type === 'product') {
      const { language } = header;
      const languagePromoBadges = item.properties?.promoBadges?.[language]?.[0] || {};
      const languageHeroBadges = item.properties?.heroBadges?.[language]?.[0] || {};
      const promoBadges = Object.values(languagePromoBadges);
      const heroBadges = Object.values(languageHeroBadges);

      const classificationData = Object.entries(item.features).reduce((acc, [key, feature]) => {
        const value = getFeatureValue(feature);
        if (value) {
          acc.push({ key, value });
        }
        return acc;
      }, []);

      const isOnSale = !!item.pricing?.was && item.pricing.was > item.pricing.price;

      const clearanceStatusCode = item.properties?.clearanceStatus?.[language];

      classificationData.push({
        key: 'clearanceStatus',
        value: CLEARANCE_STATUS_BY_CODE[clearanceStatusCode] || (isOnSale ? 'Sale' : 'Full Price'),
      });

      const localizedUrl = `/${locale.country}/${locale.language}${item.url}`;

      return mappedProducts.push({
        id: item.id,
        name: getFeatureValue(item.features.family) || 'Product',
        description: item.titles?.default || '',
        url: localizedUrl,
        heroImage: item.media?.[1]?.src || '',
        altImage: item.media?.[2]?.src || '',
        altTextSet: item.media ? Object.values(item.media).map(m => m.altText) : [],
        price: formatPrice(item.pricing?.price),
        wasPrice: formatPrice(item.pricing?.was),
        markdown: isOnSale,
        baseImage: item.media?.[1]?.src || '',
        imageSet: item.media ? Object.values(item.media).map(m => m.src) : [],
        dataLayerDescription: item.titles?.default || '',
        classificationData: {
          entry: classificationData,
        },
        variations: null,
        promoBadges: promoBadges.length >= 1 ? [promoBadges[0]] : [],
        heroBadges: heroBadges.length >= 1 ? [heroBadges[0]] : [],
        productAge: null,
        primaryCategoryName: null,
        productType: 'Shoe',
        numberOfReviews: item.properties?.reviewsCountTotal,
        averageRating: item.properties?.reviewsAverageScore,
        inWishlist: false,
        selectedSize: null,
        disableNotifyMe: false,
        page: (meta.current_page ?? 1) - 1,
        resultPosition: (meta.from ?? 1) - 1 + index,
        bestSellerRanking: item.properties?.bestSellerRanking?.[language] || null,
      });
    }
    if (item?.type === 'advert') {
      return mappedProducts;
    }

    return mappedProducts;
  });

  return {
    products: mappedProducts,
    searchMetadata: {
      totalItems: meta.count,
      facets: fullApiResponse.elements?.[template]?.products.facets,
      sortFields: mockedSortFields,
    },
  };
};
